import { PressEvent } from '@react-types/shared/src/events'
import { Add } from 'almanac-ui/icons'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { useCreateArticle } from 'hooks/useCreateArticle'
import { useNewEntrypointModal } from 'hooks/useNewEntrypointModal'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { AlmanacFile } from 'types'
import { useIsPwa } from 'utils/isPwa'

interface Props {
  disabled?: boolean
  isRootExpanded?: boolean
  expandRoot?: () => void
  showInlineCreate?: () => void
  createInRoot?: boolean
  createInFolder?: AlmanacFile | null
  onPress?: (e: PressEvent) => void
}

const AddFileButton = ({
  disabled = false,
  expandRoot,
  showInlineCreate,
  isRootExpanded,
  createInRoot = false,
  createInFolder = null,
  onPress,
}: Props) => {
  const { openNewEntrypointModal } = useNewEntrypointModal()
  const { createArticleCallback } = useCreateArticle({ openInNewTab: !useIsPwa() })
  const { isMobile } = useResponsiveDesign()

  const handleClick = async (e: PressEvent) => {
    if (!isRootExpanded && expandRoot) expandRoot()

    if (isMobile && !createInRoot) {
      // for mobile we don't open a modal just create new file
      createArticleCallback()
      return
    }

    if (showInlineCreate && !isMobile) {
      showInlineCreate()
      return
    }

    // in case we haven't selected folder we're using the default one
    openNewEntrypointModal({
      createInFolder,
    })
  }

  return (
    <IconButton
      data-testid="add-file-button"
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
      }}
      onPress={onPress || handleClick}
      isDisabled={disabled}
      icon={Add}
      size="sm"
      variant="tertiary"
      aria-label="Add new file"
    />
  )
}

export { AddFileButton }
